import { action, get, set } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default Route.extend({
  fundsService: service(),
  navbarSettings: service(),
  store: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'DonorHub');
    return this.fundsService.confirmValidFundToken();
  },

  model() {
    return this.store.query('tnt-fund', {}).then((records) => {
      return {
        record: records.slice()[0],
      };
    });
  },

  refreshDonorHub: action(function () {
    this.refresh();
  }),
});
